import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Row, Col } from 'antd';
import { useHistory } from 'react-router';
import { useForm, useFieldArray } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import { getCustomers, clearCustomers } from '../Actions';
import Breadcrumbs from '../Components/Breadcrumbs';
import StyleForm from './StyleForm';
import FabricForm from './FabricForm';

const DailyCompletionForm = props => {
  const { classes } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const { handleSubmit, control, getValues, watch, setValue, unregister } =
    useForm({
      shouldUnregister: false,
      defaultValues: {
        fabrics: [{ fabricId: null }],
        styles: [{ styleId: null }],
      },
    });

  const {
    fields: fabricFields,
    append: fabricAppend,
    remove: fabricRemove,
  } = useFieldArray({
    control,
    name: 'fabrics',
  });

  const {
    fields: styleFields,
    append: styleAppend,
    remove: styleRemove,
  } = useFieldArray({
    control,
    name: 'styles',
  });

  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    dispatch(getCustomers());
    return () => {
      dispatch(clearCustomers());
    };
  }, []);

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.post('/daily-completion', formValues);
      successNotification('Daily completion filled');
      history.push('/dailycompletion/list');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Daily Completion"
        moduleLink="/dailycompletion/list"
        subModuleName="Form"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col className={classes.tableStyle}>
            <table className={classes.inputTable}>
              <thead className={classes.inputThead}>
                <tr>
                  <th className={classes.inputTh}>Customer</th>
                  <th className={classes.inputTh}>BPO #</th>
                  <th className={classes.inputTh}>Product</th>
                  <th className={classes.inputTh}>Fabric</th>
                  <th className={classes.inputTh}>Width</th>
                  <th className={classes.inputTh}>Base Color</th>
                  <th className={classes.inputTh}>Print Color</th>
                  <th className={classes.inputTh}>Jobchart Qty</th>
                  <th className={classes.inputTh}>Process</th>
                  <th className={classes.inputTh}>Quantity</th>
                  <th className={classes.inputTh}>Remark</th>
                  <th className={classes.inputTh} style={{ width: '6%' }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {fabricFields.map((item, index) => (
                  <FabricForm
                    key={item.id}
                    fabricItem={item}
                    fabricIndex={index}
                    fabricAppend={fabricAppend}
                    fabricRemove={fabricRemove}
                    getValues={getValues}
                    setValue={setValue}
                    unregister={unregister}
                    control={control}
                    watch={watch}
                  />
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
        <br />
        <Row>
          <Col className={classes.tableStyle}>
            <table className={classes.inputTable}>
              <thead className={classes.inputThead}>
                <tr>
                  <th className={classes.inputTh}>Customer</th>
                  <th className={classes.inputTh}>BPO #</th>
                  <th className={classes.inputTh}>Product</th>
                  <th className={classes.inputTh}>Style</th>
                  <th className={classes.inputTh}>Description</th>
                  <th className={classes.inputTh}>Size</th>
                  <th className={classes.inputTh}>Base Color</th>
                  <th className={classes.inputTh}>Print Color</th>
                  <th className={classes.inputTh}>Embroidery Color</th>
                  <th className={classes.inputTh}>Acid Wash Color</th>
                  <th className={classes.inputTh}>Jobchart Qty</th>
                  <th className={classes.inputTh}>Process</th>
                  <th className={classes.inputTh}>Quantity</th>
                  <th className={classes.inputTh}>Remark</th>
                  <th className={classes.inputTh} style={{ width: '6%' }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {styleFields.map((item, index) => (
                  <StyleForm
                    key={item.id}
                    styleItem={item}
                    styleIndex={index}
                    styleAppend={styleAppend}
                    styleRemove={styleRemove}
                    getValues={getValues}
                    setValue={setValue}
                    unregister={unregister}
                    control={control}
                    watch={watch}
                  />
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
        <br />
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </Row>
      </form>
    </>
  );
};

DailyCompletionForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DailyCompletionForm);
